import classNames from "classnames";
import { Switch } from "@headlessui/react";

function ToggleButton({
  toggleState,
  setToggleState,
  disabled,
  backgroundColor,
}) {
  return (
    <Switch
      disabled={disabled}
      checked={toggleState}
      onChange={setToggleState}
      className={`${
        toggleState
          ? "bg-[#575BE8]"
          : backgroundColor
          ? backgroundColor
          : "bg-gray-500"
      } relative inline-flex items-center h-6 rounded-full w-11 ${
        disabled && "cursor-not-allowed opacity-50"
      }`}
    >
      <span
        className={classNames(
          "inline-block w-4 h-4 transform bg-white rounded-full",
          {
            "translate-x-6": toggleState,
            "translate-x-1": !toggleState,
          }
        )}
      />
    </Switch>
  );
}
export default ToggleButton;
